export default "__VITE_ASSET__09abef05__"